// styled components
import {
  Input,
  Button,
  Table,
  Empty,
  Form,
  Modal
} from "antd";
// components
import { Header } from "../../../components/Landing/Header/haeder.view";
import { BannerPostulacion } from "../components/BannerPostulacion";
import { TextoInicialJurados } from "../../Jurados/components/TextoInicialJurados";
import { Footer } from "../../../components/Landing/Footer";
// hooks
import { UseVerConvocatorias } from "../../../hooks/UseVerConvocatorias";
import { useAgregarurl } from "../../../hooks/useAgregarurl";
import { useEffect, useRef } from "react";
// icons
import { DeleteOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router";
import { DownloadHTML } from "../../../utils/DownloadFile";
import { openNotification } from "../../../utils/Notifactions";
import apiConvocatorias from "../../../api/Convocatorias/api-convocatorias";

export const AgregarURL = () => {
  // hooks
  const { convocatoria, getConvocatoria } = UseVerConvocatorias();

  const {
    nombrepropuesta,
    url,
    urls,
    cambiarnombrepropuesta,
    cambiarurl,
    agregarurl,
    eliminarurl,
    guardarurl,
    continuarurl,
    modal,
    AceptarModal,
    postulacion,
    disableButton,
    loading,
  } = useAgregarurl();

  const navigate = useNavigate();

  // Columns
  const columns: any = [
    {
      title: "No.",
      width: 60,
      render: (datos: any, datos2: any, index: number) => (
        <span>{index + 1}</span>
      ),
    },
    {
      title: "URL",
      width: 800,
      dataIndex: "url",
      key: "url",
    },
    {
      title: "Acciones",
      width: 60,
      render: (datos: any, datos2: any, index: number) => (
        <Button
          className="button-gray-ghost btn-tabla-delete d-flex justify-content-center align-items-center"
          icon={<DeleteOutlined />}
          onClick={() => eliminarurl(index)}
        />
      ),
    },
  ];

  const componentRef = useRef<any>();

  const handlePrint = () => {
    DownloadHTML(componentRef.current);
  }

  async function obtenerHoraActualColombia() {
    const response = await fetch('http://worldtimeapi.org/api/timezone/America/Bogota');
    const data = await response.json();
    const fechaYHora = new Date(data.datetime);
    return fechaYHora;
  }


  const inscribirPropuesta = async () => {
    if (!convocatoria?.fechas || convocatoria?.fechas.length < 1) {
      return openNotification({
        titulo: "Error",
        descripcion:
          "No puedes inscribirte a una convocatoria que no esté abierta",
        placement: "bottomRight",
      });
    }
    //const fechaActual = await obtenerHoraActualColombia();
    let fechaActual = new Date();
    let anio = fechaActual.getFullYear();
    let mes = ('0' + (fechaActual.getMonth() + 1)).slice(-2);
    let dia = ('0' + fechaActual.getDate()).slice(-2);
    let hora = ('0' + fechaActual.getHours()).slice(-2);
    let minutos = ('0' + fechaActual.getMinutes()).slice(-2);
    let fechaYHora = anio + '-' + mes + '-' + dia + ' ' + hora + ':' + minutos;

    const cierre = convocatoria.fechas.filter((data) => data.clave === "Cierre")[0].valormax;
    let cierreAct = new Date(cierre);
    cierreAct.setHours(cierreAct.getHours() - 1);

    let anioc = cierreAct.getFullYear();
    let mesc = ('0' + (cierreAct.getMonth() + 1)).slice(-2);
    let diac = ('0' + cierreAct.getDate()).slice(-2);
    let horac = ('0' + cierreAct.getHours()).slice(-2);
    let minutosc = ('0' + cierreAct.getMinutes()).slice(-2);
    let fechaYHoraActualizada = anioc + '-' + mesc + '-' + diac + ' ' + horac + ':' + minutosc;

    if (fechaYHoraActualizada <= fechaYHora){
      return openNotification({
        titulo: "Error",
        descripcion:
          "No puedes inscribirte a una convocatoria que no esté abierta",
        placement: "bottomRight",
      });
    }


    if (
      convocatoria?.fechas !== null &&
      convocatoria?.fechas.length > 0
    ) {
      const { data } = await apiConvocatorias.obtenerConvocatoriaConEstado(
        convocatoria?.idconvocatorias
      );
      if (data === "En espera" || data === "En proceso" || data === "Cerrada" || data ===  "No publicada") {
        return openNotification({
          titulo: "Error",
          descripcion:
            "No puedes inscribirte a una convocatoria que no esté abierta",
          placement: "bottomRight",
        });
      }
    }

    continuarurl(false)
  }

  useEffect(() => {
    getConvocatoria();
  }, []);

  return (
    <div>
      <Header />
      <BannerPostulacion convocatorias={convocatoria} />
      <div className="container-fluid2 p-md-0">
        <div className="row">
          <TextoInicialJurados
            TituloSpan="¡Estás a punto de postularte en la convocatoria!"
            TitulosinSpan="Completa los siguientes datos para finalizar. Recuerda que todos los campos son obligatorios"
          />
          <div className="container mt-4">
            <div className="row">
              <div className="col-2 font-family-Montserrat-Regular font-size-18px numero-seleccionar-postulacion">
                5
              </div>
              <div className="col font-family-Montserrat-Regular font-size-18px titulo-numero-postulacion">
                Propuesta
              </div>
            </div>
          </div>
          <div className="col-12 me-0 pe-0 mt-4">
            <span className="font-family-Montserrat-Bold font-color-707070">
              Nombre propuesta
            </span>
            <Input
              value={nombrepropuesta}
              onChange={cambiarnombrepropuesta}
              maxLength={100}
            />
          </div>
        </div>
        <div className="col-12 mt-4 me-0 pe-0 font-family-Montserrat-Regular font-size-18px titulo-numero-postulacion2">
          Agregar Enlaces
        </div>
        <Form>
          <div className="col-12">
            {convocatoria.entidad !== 'SM' && (
              <div className="font-family-Montserrat-Regular font-size-14px mt-4 ">
                Agrega los enlaces relacionados a tu propuesta cómo: página web, documentos en la nube.
              </div>
            )}
            {convocatoria.entidad == 'SM' && (
              <div className="font-family-Montserrat-Regular font-size-14px mt-4 ">
                ¡Muéstranos tu esencia! Graba un video de máximo 2 minutos en el que, de manera clara y concisa, expliques por qué tu liderazgo debe ser reconocido.
                <br />
                🎥 Puedes grabarlo con un celular inteligente, no es necesario que sea grabado por un profesional.
                <br />
                📐 Formato: MP4, pega el link de Drive o Youtube.
                <br />
                📏 Mantén tu video dentro del tiempo establecido.
                <br />
                🎤 Se recomienda grabar en horizontal para una mejor visualización.
                <br />
                💡 Grábalo en un lugar bien iluminado y sin ruidos.
                <br />
                📱 Limpia la cámara antes de grabar para una mejor calidad de imagen.
              </div>
            )}
          </div>
          <div className="col-12 mt-3">
            <span className="font-family-Montserrat-Bold font-color-707070">
              URL
            </span>
            <Input
              value={url}
              onChange={cambiarurl}
              addonAfter={
                <div
                  className="url-container"
                  onClick={() => agregarurl()}
                  style={{
                    cursor: "pointer",
                    color: "#051923bf",
                    fontSize: "12px",
                  }}
                >
                  Agregar URL
                </div>
              }
            />
          </div>

          <div className="col-12 row-shadow mt-4">
            <span className="font-color-707070 font-family-Montserrat-Bold"></span>
            <Table
              dataSource={urls}
              title={() => "Lista de enlaces agregados"}
              columns={columns}
              locale={{
                emptyText: (
                  <Empty
                    description="No has agregado ningún enlace."
                    style={{ padding: "50px" }}
                  />
                ),
              }}
            />
          </div>
        </Form>
      </div>
      <div
        style={{
          width: "100%",
          justifyContent: "center",
          marginTop: "0.5%",
          position: "sticky",
          bottom: 0,
          paddingTop: "0px",
          paddingBottom: "0%",
          background: "#FFFFFF",
          zIndex: 2,
        }}
      >
        <div className="container-fluid2 justify-content-flex-end">
          <Button
            className="button-blanco-radius font-size-12px"
            onClick={() => {
              guardarurl()
              continuarurl(true)
            }}
          >
            Guardar y salir
          </Button>
          <Button className="button-blanco-radius font-size-12px" style={{ marginLeft: "16px" }} onClick={() => navigate("/Usuario/Documentostecnicos")}>
            Atrás
          </Button>
          <Button
            className="button-azul-radius font-size-12px"
            style={{ marginLeft: "16px" }}
            disabled={disableButton || loading}
            onClick={inscribirPropuesta}
          >
            Inscribir propuesta
            {loading && (
              <i
                className="fa fa-spinner fa-spin"
                style={{ fontSize: 12, marginLeft: 4, color: "#fff" }}
              />
            )}
          </Button>
        </div>
      </div>
      <Footer />
      <div>
        <Modal
          style={{ top: 60, zIndex: 3, background: "transparent" }}
          visible={modal}
          cancelButtonProps={{ style: { display: "none" } }}
          okButtonProps={{ style: { display: "none" } }}
          closable={false}
          closeIcon=""
          width={800}
          maskStyle={{
            zIndex: 3,
            background: "rgba(0,144,76,0.8)",
          }}
          className="modal-postulacion-exitosa"
        >
          <div className="row-shadow">
            <div className="row">
              <div className="col-12 font-size-22px font-family-Montserrat-Bold d-flex justify-content-md-center texto_verde">
                Se ha completado el proceso
              </div>
              <div className="col-12 font-size-16px font-family-Montserrat-Regular justify-content-center">
                Felicidades te has postulado con éxito en la convocatoria:
              </div>
              <div className="col-12 font-size-16px font-family-Montserrat-SemiBold justify-content-center">
                Puede hacerle seguimiento desde el menú "Mis proyectos"
              </div>
            </div>
            <div className="row border-top mt-4 justify-content-flex-center">
              <div className="col-6 justify-content-flex-end">
                <Button
                  className="button-blanco-radius mb-0"
                  onClick={handlePrint}
                >
                  DESCARGAR
                </Button>
              </div>
              <div className="col-6 justify-content-flex-start">
                <Button
                  className="button-azul-radius mb-0"
                  onClick={AceptarModal}
                >
                  ACEPTAR
                </Button>
              </div>
            </div>
          </div>
          <div id="printThis" className="row-shadow mt-2">
            <div className="row">
              <div className="col-12 border-bottom font-family-Montserrat-Regular font-size-14px pb-3">
                Detalles
              </div>
            </div>
            <div
              className="row p-3"
              ref={componentRef}
              style={{ height: "600px", overflowY: "auto", fontSize: '10px', overflowWrap: 'break-word' }}
            >
              <table className="table table-bordered m-2">
                <tr>
                  <td className="table-light">Fecha:</td>
                  <td>{postulacion.fecha_creacion}</td>
                </tr>
                <tr>
                  <td className="table-light">Código Radicado:</td>
                  <td>{postulacion.radicado}</td>
                </tr>
                <tr>
                  <td className="table-light">Convocatoria:</td>
                  <td>{convocatoria.nombre_convocatoria}</td>
                </tr>
                <tr>
                  <td className="table-light">Linea Convocatoria:</td>
                  <td>{postulacion.linea_convocatoria}</td>
                </tr>
                <tr>
                  <td className="table-light">Línea Estratégica:</td>
                  <td>{convocatoria.linea_estrategica}</td>
                </tr>
                <tr>
                  <td className="table-light">Nombre representante:</td>
                  <td>{postulacion.primer_nombre} {postulacion.primer_apellido}</td>
                </tr>
                <tr>
                  <td className="table-light">Tipo Participante:</td>
                  <td>{postulacion.tipo_participante == "1"
                    ? "Persona Natural"
                    : postulacion.tipo_participante == "2"
                      ? "Persona Jurídica"
                      : "Grupo Conformado"}</td>
                </tr>
                <tr>
                  <td className="table-light">Nombre del proyecto:</td>
                  <td>{nombrepropuesta}</td>
                </tr>
                <tr>
                  <td className="table-light">Cédula/NIT:</td>
                  <td>{postulacion.numero_documento_participante}</td>
                </tr>
              </table>
            </div>
          </div>
        </Modal>
      </div>
    </div>
  );
};
